<script>
	export default {
		name: 'MessageExecuter',
		methods: {
			getMessages() {
				const self_ = this;

				const uid_ = self_.getCurrentUser('uid')

				let result_ = {}

				return new Promise((resolve, reject) => {
					Promise.resolve().then(() => {
						return self_.ipCliGetAppMessages({ senderUid: uid_ })
					}).then(result => {
						result.forEach(row => {
							result_[row.id] = row;
						})
						return self_.ipCliGetAppMessages({ toUid: uid_ })
					}).then(result => {
						result.forEach(row => {
							result_[row.id] = row;
						})
						resolve(result_)
					}).catch(error => {
						reject(error)
					})
				})
			},
			storeMessage() {
				const self_ = this;

				const datetime_ = self_.formatDate(new Date(), 'YYYY-MM-DD HH:mm:ss')

				const senderUid_ = self_.getCurrentUser('uid')
				const senderName_ = self_.getUserState('fullName')

				const toUid_ = self_.getMessageState('toUid')
				const toName_ = self_.getMessageState('toName')
				const pageName_ = self_.getMessageState('pageName')
				const pageType_ = self_.getMessageState('pageType')
				const chatCode_ = self_.getMessageState('chatCode')
				const chatName_ = self_.getMessageState('chatName')
				const title_ = self_.getMessageState('title')
				const text_ = self_.getMessageState('text')
				const attachmentFileUrl_ = self_.getMessageState('attachmentFileUrl')
				const tag_ = self_.getMessageState('tag')
				const quotedMessage_ = self_.getMessageState('quotedMessage')

				let responseTime_ = 0;
				if(!self_.isEmpty(quotedMessage_)) { responseTime_ = self_.diffDate(datetime_, quotedMessage_.datetime) }

				return self_.ipCliStoreAppMessages(datetime_, senderUid_, senderName_, toUid_, toName_, pageName_, pageType_, chatCode_, chatName_, title_, text_, attachmentFileUrl_, tag_, quotedMessage_, responseTime_)
			},
			resetMessageState() {
				const self_ = this;

				self_.setMessageState('toUid', null)
				self_.setMessageState('pageName', null)
				self_.setMessageState('pageType', null)
				self_.setMessageState('chatCode', null)
				self_.setMessageState('chatType', null)
				self_.setMessageState('title', null)
				self_.setMessageState('text', null)
				self_.setMessageState('attachmentFileUrl', null)
				self_.setMessageState('tag', [])
				self_.setMessageState('quotedMessage', {})
			},
			clearMessageState() { 
				// only clear title, text, attachment
				const self_ = this;

				self_.setMessageState('title', null)
				self_.setMessageState('text', null)
				self_.setMessageState('attachmentFileUrl', null)
			}
		}
	}
</script>